import Typography from "@mui/material/Typography";
import React from "react";

export default function Footer() {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                padding: "10px",
                backgroundColor: "rgb(22 31 59 )",
            }}
        >
            <Typography variant="body2" style={{ color: "#fcfcfcff" }}>
                © 2026 North Sails
            </Typography>
        </div>
    );
}
